/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * The constants for page ExpensesAnalyzer
 *
 * @author Fedorov Maxim
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.1.0
 */


/*
* -------------------------------------------
*           SHOW GRAPH
* -------------------------------------------
*/

export const EXPENSES_ANALYZER_SHOW_GRAPH =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_SHOW_GRAPH';


/*
* -------------------------------------------
*        SET CURRENT ACCOUNT
* -------------------------------------------
*/

export const EXPENSES_ANALYZER_SET_CURRENT_ACCOUNT =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_SET_CURRENT_ACCOUNT';

export const EXPENSES_ANALYZER_SET_SELECTED_ID =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_SET_SELECTED_ID';

/*
* -------------------------------------------
*        SET CURRENT CHART
* -------------------------------------------
*/

export const EXPENSES_ANALYZER_SET_CURRENT_CHART =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_SET_CURRENT_CHART';


/*
* -------------------------------------------
*        LOAD CHART
* -------------------------------------------
*/

export const EXPENSES_ANALYZER_LOAD_CHART =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_LOAD_CHART';
export const EXPENSES_ANALYZER_LOAD_CHART_ERROR =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_LOAD_CHART_ERROR';
export const EXPENSES_ANALYZER_LOAD_CHART_SUCCESSFUL =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_LOAD_CHART_SUCCESSFUL';

/*
* -------------------------------------------
*        UPDATE CHART
* -------------------------------------------
*/

export const EXPENSES_ANALYZER_UPDATE_CHART_ITEM =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_UPDATE_CHART_ITEM';
export const EXPENSES_ANALYZER_UPDATE_CHART_ITEM_SUCCESSFUL =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_UPDATE_CHART_ITEM_SUCCESSFUL';

/*
* -------------------------------------------
*        CONFIGURE CATEGORY CHART
* -------------------------------------------
*/

export const EXPENSES_ANALYZER_INITIALIZE_CHART =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_INITIALIZE_CHART';

/*
* -------------------------------------------
*        REDIRECT
* -------------------------------------------
*/

export const EXPENSES_ANALYZER_REDIRECT_SUBSCRIBERS_EXPENSES =
    '@@b2b_portal_ui/pageExpensesAnalyzer/REDIRECT_SUBSCRIBERS_EXPENSES';

export const EXPENSES_ANALYZER_REDIRECT_DAILY_EXPENSES =
    '@@b2b_portal_ui/pageExpensesAnalyzer/REDIRECT_DAILY_EXPENSES';

export const EXPENSES_ANALYZER_REDIRECT_CALLS_DETAIL =
    '@@b2b_portal_ui/pageExpensesAnalyzer/REDIRECT_CALLS_DETAIL';

/*
* -------------------------------------------
*        SET EXPENSES ANALYZER TYPE
* -------------------------------------------
*/

export const SET_EXPENSES_ANALYZER_TYPE =
    '@@b2b_portal_ui/pageExpensesAnalyzer/SET_EXPENSES_ANALYZER_TYPE';

/*
* -------------------------------------------
*        GET ACCOUNTS LIST (left menu)
* -------------------------------------------
*/

export const EXPENSES_ANALYZER_FULLED_ACCOUNTS_LIST =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_FULLED_ACCOUNTS_LIST';
export const EXPENSES_ANALYZER_GET_ACCOUNTS_LIST =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_GET_ACCOUNTS_LIST';
export const EXPENSES_ANALYZER_GET_ACCOUNTS_LIST_SUCCESS =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_GET_ACCOUNTS_LIST_SUCCESS';
export const EXPENSES_ANALYZER_GET_ACCOUNTS_LIST_FAILED =
    '@@b2b_portal_ui/pageExpensesAnalyzer/EXPENSES_ANALYZER_GET_ACCOUNTS_LIST_FAILED';

export const SET_EXPENSES_ANALYZER_LOADING_CHART =
    '@@b2b_portal_ui/pageExpensesAnalyzer/SET_EXPENSES_ANALYZER_LOADING_CHART';

